/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { forgetAnonymousId, getOrCreateAnonymousId } from './user-tracking';
export class SplunkSpanAttributesProcessor {
    sessionManager;
    useLocalStorageForSessionMetadata;
    getUserTracking;
    domain;
    _globalAttributes;
    constructor(sessionManager, globalAttributes, useLocalStorageForSessionMetadata, getUserTracking, domain) {
        this.sessionManager = sessionManager;
        this.useLocalStorageForSessionMetadata = useLocalStorageForSessionMetadata;
        this.getUserTracking = getUserTracking;
        this.domain = domain;
        this._globalAttributes = globalAttributes ?? {};
    }
    forceFlush() {
        return Promise.resolve();
    }
    getGlobalAttributes() {
        return this._globalAttributes;
    }
    onEnd() {
        // Intentionally empty
    }
    onStart(span) {
        span.setAttribute('location.href', location.href);
        span.setAttributes(this._globalAttributes);
        const sessionState = this.sessionManager.getSessionState();
        if (sessionState.state !== 'expired-duration') {
            span.setAttribute('splunk.rumSessionId', sessionState.id);
        }
        if (this.getUserTracking() === 'anonymousTracking') {
            span.setAttribute('user.anonymous_id', getOrCreateAnonymousId({
                domain: this.domain,
                useLocalStorage: this.useLocalStorageForSessionMetadata,
            }));
        }
        span.setAttribute('browser.instance.visibility_state', document.visibilityState);
        // Remove 'unknown_service' service.name from resource
        if (span.resource.attributes['service.name'] === 'unknown_service') {
            delete span.resource.attributes['service.name'];
        }
    }
    setGlobalAttributes(attributes) {
        if (attributes) {
            Object.assign(this._globalAttributes, attributes);
        }
        else {
            for (const key of Object.keys(this._globalAttributes)) {
                delete this._globalAttributes[key];
            }
        }
    }
    shutdown() {
        forgetAnonymousId();
        return Promise.resolve();
    }
}
//# sourceMappingURL=splunk-span-attributes-processor.js.map